import { Avatar, FormControlLabel, FormLabel, styled } from "@mui/material";

export const Image = styled(Avatar)(({ theme }) => (props) => ({
  width: "20px",
  height: "20px",
}));
export const FormLabelCus = styled(FormLabel)(({ theme }) => (props) => ({
  display: "flex",
  gap: "10px",
  alignItems: "center",
  fontSize: "20px",
  fontWeight: 400,

  " & p": {
    marginBottom: "revert !important",
  },
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}));
export const ContainerTest = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginTop: "16px",
  backgroundColor: "#fff",
  borderRadius: "10px",
  padding: "25px 32px",
  border: "1px solid rgba(0, 0, 0, 0.32)",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    padding: "12px",
    flexDirection: "column",
  },
}));
export const TestText = styled("h4")(({ theme }) => (props) => ({
  margin: "0",
  fontWight: "400",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));
const getBackgroundColor = (props) => {
  if (props.not == 0) {
    if (props?.result[0]?.student_answer == props.value) {
      return "#d32f2f";
    }

    if (
      props.testId == props?.result[0]?.question_id &&
      props?.result[0]?.correct_answer === props.value
    ) {
      return "#23B16D";
    }
    if (props?.correctId == props.testId) {
      return "#23B16D";
    }
  }
  if (props.not > 0) {
    if (props?.result[0]?.student_answer == props.value) {
      return "#d32f2f";
    }

    if (props?.correctId == props.testId) {
      return "#23B16D";
    }
  }
  if (props.chek === props.value) return "#0056D2";
  return "#f4f4f4";
};
const getColor = (props) => {
  // if (
  //   props.chek === props.value ||
  //   props?.result[0]?.student_answer === props.value ||
  //   props?.result[0]?.correct_answer === props.value
  // )
  //   return "#fff";
  // return "#000";
  if (props?.result[0]?.student_answer === props.value && props.not >= 0)
    return "#fff";
  if (props?.result[0]?.correct_answer === props.value && props.not === 0)
    return "#fff";

  // if (props.chek === props.value && props.not === 0) return "#23B16D";
  if (props.chek === props.value) return "#fff";
  return "#000";
};
export const FormLabelControlCus = styled(FormControlLabel)(
  ({ theme }) =>
    (props) => ({
      fontSize: "16px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      background: getBackgroundColor(props),
      color: getColor(props),
      padding: "10px",
      minWidth: "300px",
      marginTop: "",
      marginBottom: "16px",
      borderRadius: "12px",
      " & .muirtl-eiuvpx-MuiTypography-root": {
        fontWeight: "400",
      },
      "& .Mui-checked": {
        background: "#fff",
        padding: "0",
        margin: "5px",
      },
      " & p": {
        marginBottom: "revert !important",
      },
      " & img": {
        alignSelf: "center !important",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    })
);
